import React from "react";
import ProfileSelectScreen from "../screens/ProfileSelectScreen";
import {useProfile} from "../hooks/useProfile";

export default function ProfileRequiredRoute(element: React.ReactElement) {
  const profile = useProfile();

  return !profile.localFetched || profile.isProfileSet() ? element : <ProfileSelectScreen/>;
}
